import React from "react";
import { Message, Header } from "semantic-ui-react";
import { connect } from "react-redux";

class ErrorMessage extends React.Component {
  render() {
    const { error } = this.props;
    return (
      error.display && (
        <Message error visible>
          <Header as="h5" textAlign="center">
            {error.message}
          </Header>
        </Message>
      )
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.error
  };
};

export default connect(mapStateToProps)(ErrorMessage);



// WEBPACK FOOTER //
// ./src/components/error-message/ErrorMessage.js